import React from 'react'

import { Maintenance } from 'features/maintenance/pages/Maintenance'

export const CheatcodesScreenMaintenance = () => <Maintenance />
